

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { BASE_API_URL } from "../constants";
import { Helmet } from "react-helmet";
import "../CSS/BlogView.css";
import {
    FaFacebook,
    FaWhatsapp,
    FaTwitter,
    FaLinkedin,
    FaShareAlt
} from "react-icons/fa";

const BlogView = () => {
    const { id } = useParams();
    const [blog, setBlog] = useState(null);

    useEffect(() => {
        const fetchSingleBlog = async () => {
            try {
                const res = await fetch(`${BASE_API_URL}/api/get-blogs`);
                const allBlogs = await res.json();
                const found = allBlogs.find((item) => String(item.id) === String(id));
                setBlog(found);
            } catch (error) {
                console.error("Error loading blog:", error);
            }
        };
        fetchSingleBlog();
    }, [id]);

    if (!blog) return <p style={{ color: "white" }}>Loading...</p>;

    // ----------------------------
    //  SHARE URL GENERATION
    // ----------------------------
    const shareUrl = window.location.href;
    const shareTitle = blog.title;
    const shareDesc = blog.excerpt || blog.title;

    const shareOnFacebook = () => {
        window.open(
            `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
            "_blank"
        );
    };

    const shareOnWhatsApp = () => {
        window.open(
            `https://wa.me/?text=${encodeURIComponent(shareTitle + " - " + shareUrl)}`,
            "_blank"
        );
    };

    const shareOnTwitter = () => {
        window.open(
            `https://twitter.com/intent/tweet?url=${encodeURIComponent(
                shareUrl
            )}&text=${encodeURIComponent(shareTitle)}`,
            "_blank"
        );
    };

    const shareOnLinkedIn = () => {
        window.open(
            `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
                shareUrl
            )}&title=${encodeURIComponent(shareTitle)}&summary=${encodeURIComponent(
                shareDesc
            )}`,
            "_blank"
        );
    };

    const copyShareLink = () => {
        navigator.clipboard.writeText(shareUrl)
            .then(() => {
                alert(" Link copied! You can share it with anyone.");
            })
            .catch(() => {
                alert("Failed to copy link.");
            });
    };


    return (
        <>
            <Helmet>
                <title>{blog.title}</title>

                <meta name="description" content={shareDesc} />

                {/* OpenGraph */}
                <meta property="og:title" content={blog.title} />
                <meta property="og:description" content={shareDesc} />
                <meta property="og:image" content={blog.featuredImage} />
                <meta property="og:type" content="article" />
                <meta property="og:url" content={shareUrl} />

                {/* Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={blog.title} />
                <meta name="twitter:description" content={shareDesc} />
                <meta name="twitter:image" content={blog.featuredImage} />
            </Helmet>

            <div className="blogview-wrapper">
                {/*  Sidebar Same As Updates.js */}


                <div className="single-blog-container">
                    {/* <Sidebar
                        isOpen={isSidebarOpen}
                        toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
                    /> */}

                    {/*  BACK BUTTON */}
                    <button
                        onClick={() => window.location.href = "/updates"}
                        className="back-btn"
                    >
                        Back
                    </button>

                    {/* Featured Image */}
                    {blog.featuredImage && (
                        <img
                            src={blog.featuredImage}
                            alt={blog.title || "Blog featured"}
                            className="single-blog-image"
                        />
                    )}

                    {/* Title */}
                    <h1 className="single-blog-title">{blog.title}</h1>

                    {/* Meta */}
                    <p className="single-blog-meta">
                        <strong>Author:</strong> {blog.author} {" "}
                        {new Date(blog.dateCreated).toLocaleDateString()}
                    </p>

                    {/* SHARE BUTTONS */}
                    <div className="share-buttons">
                        <button onClick={shareOnFacebook} className="share-btn fb">
                            <FaFacebook />
                        </button>

                        <button onClick={shareOnWhatsApp} className="share-btn wa">
                            <FaWhatsapp />
                        </button>

                        <button onClick={shareOnTwitter} className="share-btn tw">
                            <FaTwitter />
                        </button>

                        <button onClick={shareOnLinkedIn} className="share-btn li">
                            <FaLinkedin />
                        </button>

                        {/*  NEW  Copy Share Link Button */}
                        <button onClick={copyShareLink} className="share-btn copy">
                            <FaShareAlt />
                        </button>

                    </div>

                    {/* Content */}
                    <div
                        className="single-blog-content"
                        dangerouslySetInnerHTML={{ __html: blog.content }}
                    ></div>
                </div>
            </div>
        </>
    );
};

export default BlogView;
